import { createSelector } from 'reselect';

const getUser = (state) => state.user

export const getFullUser= createSelector(
    [ getUser ],
    ( user ) => {
        return user;
    }
)


// WEBPACK FOOTER //
// ./src/selectors/user.selector.js